// extracted by mini-css-extract-plugin
export var bodySections = "_4d-8";
export var gray = "_4d-7";
export var green = "_4d-4";
export var iconContainer = "_4d-9";
export var iconWidgetContainer = "_4d-1";
export var phoneIcon = "_4d-2";
export var red = "_4d-5";
export var statusDot = "_4d-3";
export var widgetContainer = "_4d-0";
export var yellow = "_4d-6";